import { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';

import { FeatureFlag } from '../enums';
import Cookie from '../types/Cookies';

import useFeature from './useFeature';

const cookies = new Cookies();

const isRamOneAuthenticated = () =>
  cookies.get(Cookie.TOKEN) &&
  cookies.get(Cookie.SIGNATURE) &&
  cookies.get(Cookie.WEB_ID) &&
  cookies.get(Cookie.INSTALL_ID);

const useRamOneAuthentication = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(isRamOneAuthenticated());
  const useRam1 = useFeature(FeatureFlag.UseRam1);

  const updateLoginStatus = () => {
    setIsAuthenticated(isRamOneAuthenticated());
  };

  useEffect(() => {
    window.addEventListener('loggedIn', updateLoginStatus);
    window.addEventListener('loggedOut', updateLoginStatus);

    return () => {
      window.removeEventListener('loggedIn', updateLoginStatus);
      window.removeEventListener('loggedOut', updateLoginStatus);
    };
  }, []);

  return useRam1 && isAuthenticated;
};

export default useRamOneAuthentication;
